export const Footer = (props) => {
    const {
        screenSize,
    } = props;
    return (
        <div className={`app-footer ${screenSize === 'small' ? 'small-screen' : ''}`}>
            Rios Partners all rights reserved. 
        </div>
    )
}